import CacheWithExpiration from './cacheWithExpiration';
import * as indexedDb from './indexedDb';

export default class IndexedDbCache extends CacheWithExpiration {
  constructor(keyNamespace: string) {
    // Set the database name using the keyNamespace
    indexedDb.setDatabaseName(keyNamespace);
    super(indexedDb, keyNamespace, true);
  }
}
